import FillEntity from './FillEntity';

export default FillEntity;
